import styled from "styled-components";


export const ExternalLinkIframeContainerBox = styled.div<{maxWidth: number; maxHeight: number; isMobileOS: boolean}>`
  position: relative;
  max-width: ${props => props.maxWidth + 'px'};
  max-height: ${props => props.maxHeight + 'px'};
  
  width: ${props => props.isMobileOS ? '100vw' : 'calc(100vw - 30px)'};
  height: ${props => props.isMobileOS ? '100vh' : 'calc(100vh - 30px)'};
  box-sizing: border-box;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    max-width: unset;
    max-height: unset;
  }
`
